export default __webpack_public_path__ + "static/media/zeroshotbot-horizontal-medium.4d9fc11b.svg";